import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CountryTranslateService } from './country-translate.service';

@UntilDestroy()
@Pipe({
  name: 'countryAsync',
})
export class CountryPipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(private injector: Injector, private countryService: CountryTranslateService) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
    this.countryService.loadCountyListIfNeed();
  }

  transform(value: string, ...args: unknown[]): Observable<string> {
    if (!value) {
      return of(value);
    }
    return this.countryService.countryList$.pipe(untilDestroyed(this)).pipe(
      map((countryList) => {
        value = value.toUpperCase();
        if (countryList[value]) {
          return countryList[value];
        }
        return value;
      }),
    );
  }

  ngOnDestroy() {
    this.asyncPipe.ngOnDestroy();
  }
}
